import { apiFetch } from "./client.js";

export type TransactionType = "withdrawal" | "deposit" | "chores" | "gift" | "adjustment";

export interface PostTransactionBody {
  kidId: string;
  amountCents: number;
  note: string;
  type: TransactionType;
}

export interface PostTransactionResponse {
  account: { balanceCents: number; allowanceCents: number; otherIncomeCents: number };
  txn: {
    rowKey: string;
    date: string;
    type: string;
    amountCents: number;
    note: string;
  };
}

export async function postTransaction(body: PostTransactionBody): Promise<PostTransactionResponse> {
  return apiFetch<PostTransactionResponse>(
    "/api/transactions",
    { method: "POST", body: JSON.stringify(body) },
    true,
  );
}

export async function deleteTransaction(kidId: string, rowKey: string): Promise<void> {
  await apiFetch<{ ok: true }>(
    `/api/transactions/${encodeURIComponent(kidId)}/${encodeURIComponent(rowKey)}`,
    { method: "DELETE" },
  );
}
